// "New since your last visit" counts for the sidebar: relevant funding calls and interests (backend:
// registry/user/relevance.py). markSeen(page) when the person opens that page; the chip clears.
import useSWR, { mutate } from 'swr';
import { axiosService, fetcher } from 'shared/helpers/axios';

export const NEW_COUNTS_KEY = '/users/me/new-counts/';

export function useNewCounts(enabled = true) {
  const { data } = useSWR(enabled ? NEW_COUNTS_KEY : null, fetcher, { refreshInterval: 10 * 60 * 1000 });
  return data || { funding: 0, interests: 0, has_relevance: false };
}

export async function markSeen(page) {
  try {
    const { data } = await axiosService.post(NEW_COUNTS_KEY, { page });
    mutate(NEW_COUNTS_KEY, data, false);
  } catch { /* the chip clears on the next visit */ }
}
